export default {
  chooseFile: "Datei auswählen",
  browse: "Durchsuchen",
  clearFile: "Datei löschen",
  color: {
    hexValue: "Hexadezimalwert der Farbe",
    presets: "Vordefinierte Farben",
    noColor: "Keine Farbe ausgewählt",
    picker: "Farbauswahl",
    open: "Farbauswahl öffnen",
    saturation: "Sättigung und Helligkeit",
    saturationValue: "Sättigung {saturation} %, Helligkeit {value} %",
    hue: "Farbton",
    red: "Rot (0 bis 255)",
    green: "Grün (0 bis 255)",
    blue: "Blau (0 bis 255)",
  },
  icon: {
    list: "Symbolliste",
    selected: "Ausgewähltes Symbol",
    invalid: "Bitte wählen Sie ein gültiges FontAwesome-Symbol (light)",
    library: "Finden Sie die FontAwesome-Symbolbibliothek",
  },
  empty_icon: "Geben Sie einen Symbolnamen ein (z. B. check)",
  function: "Funktion",
  requiredField: "Dieses Feld ist obligatorisch",
  at_least_one_field_required: "Sie müssen mindestens eine Option in dieser Zeile ankreuzen",
  requiredNumberOrFloat: "Bitte geben Sie eine ganze oder dezimale Zahl ein",
  emailError: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  phoneError: "Bitte geben Sie eine gültige Telefonnummer ein",
  lastName: "Nachname",
  firstName: "Vorname",
  email: "E-Mail",
  address: "Adresse",
  complement: "Ergänzung",
  postCode: "Postleitzahl",
  city: "Stadt",
  phone: "Telefon",
  mobile: "Mobil",
  actions: "Aktionen",
  rights: "Rechte",
  send: "Senden",
  errors: "Achtung, es gibt Fehler",
  form_validation: "Folgende Felder sind obligatorisch:",
  entitled: "Bezeichnung",
  signed_success: "Erfolgreich signiert",
  title: "Titel",
  selectValue: "Einen Wert auswählen",
  uploaded_on: "Online gestellt am",
  error_file: "Ups, die Datei scheint nicht verfügbar zu sein",
  no_skill_error_file: "Dieser Kompetenz-Import ist leer",
  download_success: "Datei erfolgreich heruntergeladen!",
  file_downloading: "Download läuft...",
  download_file: "Datei herunterladen",
  remove_file: "Datei entfernen",
  signed_error: "Ups, beim Speichern ist ein Fehler aufgetreten",
  saving: "Speicherung läuft",
  confirm: "Bestätigen",
  apply: "Anwenden",
  generate: "Generieren",
  import: "Importieren",
  error_nofile: "Sie müssen eine Datei hinzufügen",
  error_file_format: "Bitte fügen Sie eine Datei im richtigen Format hinzu!",
  error_date: "Bitte geben Sie ein Startdatum ein, das vor dem Enddatum liegt",
  link: "Link öffnen",
  dateChoice: "Klicken Sie, um ein Datum auszuwählen",
  next: "Weiter",
  formTabPrevious: "Zurück",
  formTabNext: "Weiter",
  pleaseWait: "Bitte warten...",
  select: "Auswählen",
  cancel: "Abbrechen",
  save: "Speichern",
  leave_without_save: "Ohne Speichern verlassen",
  leave_confirmation: "Möchten Sie wirklich schließen ohne zu speichern?",
  ok: "OK",
  edit: "Bearbeiten",
  overview: "Vorschau",
  synchronize: "Synchronisieren",
  no: "Nein",
  yes: "Ja",
  warning: "Achtung",
  iConfirm: "Ich bestätige",
  Save: "Speicherung",
  saveFinish: "Die Speicherung ist abgeschlossen",
  fileFormatError: "Bitte wählen Sie eine Datei im richtigen Format aus",
  display: "Anzeigen",
  elements: "Elemente",
  lines: "Zeilen",
  conditions: {
    title: "Anwendungsbedingung der Vorlage",
    info: "Um spezifische Vorlagen zu erstellen, duplizieren Sie bitte die Standardvorlage und definieren Sie die Anwendungsbedingungen (Registerkarte 3)",
    alerte:
      "Standardmäßig gilt die Standardvorlage für alle Fälle. Wenn Sie unten Bedingungen festlegen, wird die Vorlage nur angewendet, wenn alle Bedingungen erfüllt sind (UND-Logik).",
  },
  pagination: {
    to: "bis",
    on: "von",
  },
  close: "Schließen",
  submit: "Senden",
  submit_success: "Formular erfolgreich gesendet!",
  back: "Zurück",
  remove: "Entfernen",
  regenerate: "Neu generieren",
  typeYourSearch: "Suche eingeben...",
  sortBy: "Sortieren nach",
  order: "Reihenfolge",
  desc: "Absteigend",
  asc: "Aufsteigend",
  reset: "Zurücksetzen",
  filter: "Filtern",
  Search: "Suchen",
  "No data available in the table": "Keine Daten in der Tabelle verfügbar",
  "No data available": "Keine Daten verfügbar",
  "Please enter or modify your search": "Bitte geben Sie Ihre Suche ein oder ändern Sie sie",
  "Please click on the add button": "Bitte klicken Sie auf die Schaltfläche zum Hinzufügen",
  search: "Suchen",
  All: "Alle",
  None: "Keine",
  choicesScrollLabel: "Liste der Auswahlmöglichkeiten, scrollbar",
  "PDF export": "PDF-Export",
  "Excel export": "Excel-Export",
  "PNG export": "PNG-Export",
  "SVG export": "SVG-Export",
  "See statistics": "Statistiken anzeigen",
  multiselect: {
    press_enter: "",
    press_enter_group: "",
    selected: "",
    press_enter_remove: "",
    press_enter_remove_group: "",
    press_enter_create_tag: "Einen Wert hinzufügen",
    select_option: "",
    no_result: "Kein Ergebnis entspricht Ihrer Suche",
    no_options: "Geben Sie mindestens {nb} Zeichen ein, um Ergebnisse zu suchen...",
  },
  init_search: "Suche zurücksetzen",
  search_motor: "Suchmaschine",
  file_size_error: "Die ausgewählte Datei ist zu groß, bitte wählen Sie eine Datei unter ",
  video_not_supported_mobile: "Das Hinzufügen eines Videos ist über die mobile App nicht möglich",
  maxTagError: "Bitte halten Sie die maximale Anzahl der Werte ein",
  minTagError: "Bitte halten Sie die minimale Anzahl der Werte ein",
  see_more_fields: "Weitere Felder anzeigen",
  justificative_piece: "Belege",
  skillRecap: "Kompetenzübersicht",
  option_value: "Wert",
  option_label: "Label",
  light: "Hell",
  dark: "Dunkel",
  system: "System",
  extensions_accepted:
    "Bitte wählen Sie eine Datei vom Typ pdf, doc, xls, xlsx, csv, docx, jpeg, svg, bmp, gif oder png aus",
  extensions_accepted_document_image:
    "Bitte wählen Sie eine Datei vom Typ pdf, doc, docx, xls, xlsx, pptx, gif, jpeg oder png aus",
  valid: "Validieren",
  unlock: "Entsperren",
  tab_error: "Es gibt einen Fehler in diesem Tab",
  tab_status_pending: "Tab ausstehend",
  tab_status_in_progress: "Tab in Bearbeitung",
  tab_status_completed: "Tab abgeschlossen",
  regenerate_succes: "Kennung erfolgreich neu generiert!",
  password_validation: {
    title: "Bitte geben Sie ein Passwort ein, das folgendes enthält:",
    condition1: "Einen Großbuchstaben",
    condition2: "Einen Kleinbuchstaben",
    condition3: "Eine Ziffer",
    condition4: "Ein Sonderzeichen",
    condition5: "Mindestens 12 Zeichen",
  },
  dropzone: {
    release: "Dateien hier ablegen, um sie hinzuzufügen.",
    drop: "Dateien hier ablegen oder",
    click_here: "klicken",
    to_upload: "zum Hinzufügen.",
    downloading: "Download läuft...",
    file: "Datei",
    max_files: "Maximal {count} Dateien",
    max_files_message: "Sie haben das zulässige Dateilimit erreicht.",
    max_file_size: "Die Dateigröße {name} überschreitet das zulässige Limit.",
    file_extension_error: "Die Dateierweiterung {name} ist ungültig.",
    error_title: "Achtung, einige Dateien wurden nicht akzeptiert.",
    file_size_error: "Die maximale Größe pro Datei beträgt {size} MB.",
    upload_timeout_error:
      "Der Datei-Upload hat zu lange gedauert und wurde abgebrochen. Bitte versuchen Sie es erneut.",
  },
  upload_signed_document: {
    label: "Das unterzeichnete Dokument einreichen",
    one_file: "Sie müssen mindestens 1 Datei einfügen",
    file_only: "Bitte wählen Sie eine PDF-Datei aus",
  },
  user_permissions: {
    archive_label: "Archivierte Beförderungen anzeigen",
    profile_label: "Alle aktiven Profile anzeigen",
    search_label: "Suchen...",
    title: "Liste der Benutzerprofile",
    choose_profile: "Wählen Sie das hinzuzufügende Profil",
  },
  form_error: {
    verify_fields:
      "Einige Felder des Formulars enthalten Fehler, bitte überprüfen Sie diese und senden Sie das Formular erneut",
    minimum_value: "Mindestwert: {value}",
    maximum_value: "Höchstwert: {value}",
  },
  editor: {
    image_upload_error: "Fehler beim Hochladen des Bildes",
    image_read_error: "Fehler beim Lesen des Bildes",
    file_upload_error: "Fehler beim Hochladen der Datei",
    file_read_error: "Fehler beim Lesen der Datei",
    insert_image: "Bild einfügen",
    image_size_title: "Bildgröße",
    image_alt: "Alternativtext",
    image_width: "Breite",
    image_height: "Höhe",
  },
  filePicker: {
    camera: "Kamera",
    files: "Dateien",
    pictures: "Fotos",
    clipboard_no_image: "Die Zwischenablage enthält kein Bild",
    clipboard_unavailable: "Zugriff auf die Zwischenablage nicht möglich",
    permission_denied_camera:
      "Der Kamerazugriff wurde verweigert. Bitte erlauben Sie ihn in den Einstellungen Ihres Geräts.",
    permission_denied_photos:
      "Der Zugriff auf die Fotos wurde verweigert. Bitte erlauben Sie ihn in den Einstellungen Ihres Geräts.",
    error: "Beim Abrufen der Datei ist ein Fehler aufgetreten",
  },
  slider: {
    start: "Start",
    in_progress: "Läuft",
    end: "Abgeschlossen",
  },
  writing_assistant: {
    title: "Schreibassistent",
    disable: "Assistenten deaktivieren",
    toggle_label: "KI-Assistent",
    helpful: "Diese Frage hat mir geholfen",
    dismiss: "Diese Frage ausblenden",
    loading: "Fragen werden generiert…",
    unavailable: "Der Assistent ist vorübergehend nicht verfügbar",
    questions_announce: "{count} Frage des Assistenten | {count} Fragen des Assistenten",
    minutes: "{count} Minute | {count} Minuten",
    minutes_short: "{count} Min.",
    paused: "Pause bei {field} · wieder da in {duration}",
    paused_many: "Pause bei {count} Feldern · nächste Rückkehr in {duration}",
    paused_announce: "Der Assistent ist bei {fields} pausiert; wieder verfügbar in {duration}.",
    resumed_announce: "Der Assistent ist bei {fields} wieder verfügbar.",
    field_quoted: "„{field}“",
    fields: {
      contexte: "Kontext",
      taches: "Aufgaben",
      difficultes: "Schwierigkeiten",
      resultats: "Ergebnisse",
      apprentissages: "Lernerfahrungen",
      unknown: "dieses Feld",
    },
    info: {
      aria_label: "Wie funktioniert der KI-Assistent?",
      title: "Wie funktioniert das?",
      purpose: "Der Assistent stellt dir Fragen, damit du deinen Text ausführlicher formulieren kannst.",
      triggers: "Er startet von selbst, wenn dein Text {threshold} Zeichen erreicht, nach einer kurzen Schreibpause.",
      limit:
        "Maximal {max} Vorschläge pro Feld. Sind sie aufgebraucht, ist der Assistent in diesem Feld nach {duration} wieder verfügbar.",
    },
  },
  date_error: {
    date_format_error: "Das Datumsformat ist ungültig",
    date_min_error: "Das Datum muss strikt nach dem Feld {fieldName} liegen",
    date_max_error: "Das Datum muss strikt vor dem Feld {fieldName} liegen",
  },
  number_error: {
    number_format_error: "Das Zahlenformat ist ungültig",
    number_min_error: "Dieses Feld muss kleiner oder gleich dem Feld {fieldName} sein",
    number_max_error: "Dieses Feld muss größer oder gleich dem Feld {fieldName} sein",
  },
};
